import React from 'react';
import { Button, Typography, Form, Upload, message } from 'antd';

const { Title, Paragraph } = Typography;

const Step1 = ({ form, next }) => {
  const onFinish = () => {
    form
      .validateFields()
      .then(values => {
        console.log('Step 1 Form Values:', values);
        next();
      })
      .catch(errorInfo => {
        console.log('Validation Failed:', errorInfo);
        message.error('Please complete all required fields.');
      });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
    >
      <div style={{ maxWidth: 800, margin: '0 auto', textAlign: 'center' }}>
        <Title level={2}>Driver ID Application</Title>
        <Paragraph>
          Welcome to the first step of becoming a Opera Taxis Cabs Driver!
        </Paragraph>
        <Paragraph>
          Completing this application doesn't guarantee approval; it's just to gather information. If approved, you'll get an email with your login details to proceed further.
        </Paragraph>

        <Paragraph>
          {/* Approval of your GM ID application will also approve yourself to be on the RYDO booking system through your opera taxis Cabs Eftpos Machine. */}
        </Paragraph>
        <Paragraph>
          If you're ready to continue, please select 'Next' below.
        </Paragraph>
        <Paragraph>
          <b>Documents required for this Application:</b>
        </Paragraph>
        <ul style={{ textAlign: 'left', display: 'inline-block' }}>
          <li>Your driver's license</li>
          <li>Criminal History Check/Taxi Council License</li>
          <li>Emergency Contact Details</li>
        </ul>
        <div style={{ marginTop: 20 }}>
          <img src="/logo.png" style={{ width: 200, height: 'auto' }} alt="Opera Taxis Cabs Logo" />
        </div>
        <div style={{ marginTop: 20 }}>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Next
            </Button>
          </Form.Item>
        </div>
      </div>
    </Form>
  );
};

export default Step1;
